// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__17ZYT","Open":"SideDrawer_Open__oXCqy","Close":"SideDrawer_Close__1ME6k"};